// extracted by mini-css-extract-plugin
module.exports = {"emptyRegistry":"emptyRegistry__3fwjc"};